import React, { useEffect, useState } from "react";
import firebase from "firebase/app";
import {
  Button,
  Dropdown,
  Form,
  Icon,
  Label,
  Menu,
  Message,
  Segment,
} from "semantic-ui-react";

import descriptor from "../descriptor.json";
// import { PDFObject } from "pdf-lib";
const FormMenu = ({ enums }) => {
  const [activeItem, setState] = useState("");
  const [data, setData] = useState({});
  // const [tempObj, setTempObj] = useState({});

  useEffect(() => {
    firebase
      .firestore()
      .collection("formMaps")
      .doc(enums)
      .get()
      .then((doc) => {
        setData({ ...doc.data() });
      })
      .catch((err) => {
        global.alert(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // const typeObj = data[activeItem];
  // const isKeyEmpty = async (data) => {
  //   // Object.keys(data[enums]).forEach((item) => {
  //   //   return Object.keys(item).filter((item) => item.key === "");
  //   // });
  //   const enumArr = ["primary", "secondary", "interpreter", "preparer"];
  //   for (let i = 0; i < 4; i++) {
  //     return data[enumArr[i]].some((item) => item.key === "");
  //   }
  // };

  // TODOs Burada Kaldım. handleClick state'i güncellemeli.
  const handleClick = async (name) => {
    await setState(name);
  };

  const handleChange = async (value, item) => {
    const tempObj = await data[activeItem];

    const editMap = await tempObj.map((e) =>
      e.value === item.value
        ? {
            ...item,
            key: value,
          }
        : e
    );

    await setData({
      ...data,
      [activeItem]: editMap,
    });
  };

  const handleUpdate = async () => {
    // Object.values(data).
    await firebase
      .firestore()
      .collection("formMaps")
      .doc(enums)
      .set(data)
      .then(() => {
        global.alert("Successfull");
        setData(data);
      })
      .catch((err) => {
        global.alert(err);
      });
  };

  return (
    <>
      <Menu pointing>
        <Menu.Item
          name="preparer"
          active={activeItem === "preparer"}
          onClick={(e, { name }) => handleClick(name)}
        />
        <Menu.Item
          name="primary"
          active={activeItem === "primary"}
          onClick={(e, { name }) => handleClick(name)}
        />
        <Menu.Item
          name="secondary"
          active={activeItem === "secondary"}
          onClick={(e, { name }) => handleClick(name)}
        />
        <Menu.Item
          name="interpreter"
          active={activeItem === "interpreter"}
          onClick={(e, { name }) => handleClick(name)}
        />
      </Menu>
      {activeItem !== "" ? (
        <Segment>
          {data[activeItem] &&
            data[activeItem].map((item) => {
              return (
                <Form key={enums}>
                  <Segment color="violet">
                    <Form.Field width={16}>
                      {item.value} ({item.type})
                      {item.key !== "" ? (
                        <Label as="a" color="teal" tag>
                          {item.key}
                        </Label>
                      ) : (
                        <Label as="a" color="red">
                          <Icon name="key" /> No Key
                        </Label>
                      )}
                    </Form.Field>
                    <Dropdown
                      inline
                      clearable
                      search
                      fluid
                      item={item}
                      key={item.value}
                      options={descriptor}
                      onChange={(e, { value }) => handleChange(value, item)}
                      placeholder="Select a descriptor"
                    />
                  </Segment>
                </Form>
              );
            })}
          <Segment>
            <Button color="teal" fluid onClick={() => handleUpdate()}>
              Update
            </Button>
          </Segment>
        </Segment>
      ) : (
        <Message>Please choose a person type</Message>
      )}
    </>
  );
};

export default FormMenu;
